module.exports = __webpack_public_path__ + "media/images/icon-comm-879b40fd9a1c640094fccd2fb5d53b4c.svg";